export const AUDITORY_MODEL = {
  paso: 2,
  pasoDescripcion: 'PASO_ASEGURADOS',
};
